import React from 'react';
import { Card, CardContent, CardHeader } from './ui/card';
import { cn } from "@/lib/utils";

interface TermDefinition {
  term: string;
  definition: string;
}

interface TermsDescriptionsProps {
  terms: TermDefinition[];
  title?: string;
}

const TermsDescriptions: React.FC<TermsDescriptionsProps> = ({ 
  terms, 
  title = "Term Definitions" 
}) => {
  if (!terms || terms.length === 0) {
    return null;
  }

  return (
    <div className="w-full mt-6">
      <Card className="w-full">
        <CardHeader>
          <h3 className={cn("text-xl font-semibold")}>{title}</h3>
        </CardHeader>
        <CardContent>
          <div className={cn("space-y-4")}>
            {terms.map((termDef, index) => (
              <div key={index} className={cn("border-b border-slate-200 dark:border-slate-700 pb-3 last:border-b-0")}>
                <dt className={cn("font-medium text-slate-700 dark:text-slate-300 mb-1")}>
                  {termDef.term}
                </dt>
                <dd className={cn("text-slate-500 dark:text-slate-400 text-sm leading-relaxed")}>
                  {termDef.definition}
                </dd>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TermsDescriptions;